// Vue 3 router setup migrated from Vue 2 project
import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router';
import type { RouteLocationNormalized, NavigationGuardNext, RouteLocation } from 'vue-router';
import { AVAILABLE_YEARS } from './composables/useYear';
import Splash from './views/splash.vue';
import Chart from './views/chart.vue';
import Contents from './views/contents.vue';
import Respondents from './views/respondents.vue';
import Contact from './views/contact.vue';
import TransactionCosts from './views/transaction-costs.vue';
import TermsAndConditions from './views/terms-and-conditions.vue';
import AppLayout from './components/AppLayout.vue';
import NotFound from './views/not-found.vue';

const validYears = AVAILABLE_YEARS;

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: 'Homepage' },
    component: Splash,
  },
  {
    path: '/terms-and-conditions',
    meta: { title: 'Terms & Conditions' },
    component: TermsAndConditions,
  },
  {
    // Wrapper route for Contact to use AppLayout without year param
    path: '/contact',
    component: AppLayout,
    children: [
      {
        path: '',
        name: 'contact',
        meta: { title: 'Contact us' },
        component: Contact,
      }
    ]
  },
  {
    // Wrapper route for internal pages using AppLayout with Year prefix
    path: '/:year(\\d{4})',
    component: AppLayout,
    redirect: (to: RouteLocation) => { return { name: 'contents', params: { year: to.params.year } } },
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      const year = to.params.year;
      if (typeof year === 'string' && validYears.includes(year)) {
        next();
      } else {
        next({ path: '/' });
      }
    },
    children: [
      {
        path: 'chart',
        redirect: (to: RouteLocation) => { return { name: 'contents', params: { year: to.params.year } } }
      },
      {
        path: 'chart/:pathname',
        name: 'chart',
        component: Chart,
        props: true,
      },
      {
        path: 'transaction-costs',
        name: 'transaction-costs',
        meta: { title: 'Transaction costs' },
        component: TransactionCosts,
      },
      {
        path: 'contents',
        name: 'contents',
        meta: { title: 'How to use' },
        component: Contents,
      },
      {
        path: 'respondents',
        name: 'respondents',
        meta: { title: 'List of respondents' },
        component: Respondents,
      },
      {
        path: ':pathMatch(.*)*',
        name: 'NotFoundYear',
        meta: { title: 'Page not found' },
        component: NotFound,
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: AppLayout,
    children: [
      {
        path: '',
        name: 'NotFound',
        meta: { title: 'Page not found' },
        component: NotFound,
      }
    ]
  }
];

export const router = createRouter({
  history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
  routes,
});

export { routes }; // Export routes for SSG

export default router;
